export const titleHTML = (title) => {
  document.title = title;
};
